export default {
    mutateCommonProperties ({ commit }, payload) {
      commit('mutateCommonProperties', payload)
    },
    mutateWarehouseProperties ({ commit }, payload) {
        commit('mutateWarehouseProperties', payload)
    },
    mutateAgriMarketingProperties ({ commit }, payload) {
        commit('mutateAgriMarketingProperties', payload)
    },
    mutateIncentiveGrantServiceProperties ({ commit }, payload) {
        commit('mutateIncentiveGrantServiceProperties', payload)
    },
    mutateLicenseRegistrationServiceProperties ({ commit }, payload) {
      commit('mutateLicenseRegistrationServiceProperties', payload)
    },
    changeCommonDropdown ({ commit }, payload) {
      commit('changeCommonDropdown', payload)
    },
    localizeDropdownCommonConfig ({ commit }, payload) {
      commit('localizeDropdownCommonConfig', payload)
    },
    changeWarehouseDropdown ({ commit }, payload) {
        commit('changeWarehouseDropdown', payload)
    },
    changeAgriMarketingDropdown ({ commit }, payload) {
      commit('changeAgriMarketingDropdown', payload)
    },
    changeLicenseRegistrationDropdown ({ commit }, payload) {
      commit('changeLicenseRegistrationDropdown', payload)
    },
    setOrgList ({ commit }, payload) {
      commit('setOrgList', payload)
    },
    setList ({ commit }, payload) {
      commit('setList', payload)
    },
    resetList ({ commit }) {
      commit('resetList', [])
    },
    setNotificationList ({ commit }, payload) {
      commit('setNotificationList', payload)
    },
    setPushNotification ({ commit }, payload) {
      commit('setPushNotification', payload)
    },
    removeSinglePushNotification ({ commit }, payload) {
      commit('removeSinglePushNotification', payload)
    },
    setTotalNotification ({ commit }, payload) {
      commit('setTotalNotification', payload)
    },
    isToggleNotification ({ commit }, payload) {
      commit('isToggleNotification', payload)
    },
    removeItemFromSetList ({ commit }, payload) {
      commit('removeItemFromSetList', payload)
    },
    toggleStatus ({ commit }, payload) {
      commit('toggleStatus', payload)
    },
    toggleDropdownItemStatus ({ commit }, payload) {
      commit('toggleDropdownItemStatus', payload)
    },
    resetState ({ commit }) {
      commit('resetState')
    },
    // Called on every successful login: public portal page data isn't needed inside the
    // panels (Portal.serviceUrl is kept - it carries the page the user came from)
    resetPortalStores ({ commit }) {
      commit('Portal/resetPortalState')
      commit('PortalFaq/resetPortalState')
      commit('PortalNotice/resetPortalState')
      commit('PortalNews/resetPortalState')
      commit('PortalAllServices/resetPortalState')
      commit('PortalServices/resetPortalState')
      commit('PortalServiceDetails/resetPortalState')
      commit('PortalProductDetails/resetPortalState')
      commit('PortalNewsDetails/resetPortalState')
    },
    // Called once on every full page load (main.js): the store is persisted to localStorage, so
    // without this the "already loaded" flags survive a reload and pages never refetch. Only the
    // flags/caches are cleared - stored dropdown data stays until the fresh response replaces it.
    // In-app navigation keeps the flags, so it still reuses the stored data.
    refreshOnPageLoad ({ commit }) {
      // helpLineNumber is kept: the login/dashboard layouts refresh it, the panels reuse it
      commit('mutateCommonProperties', { hasDropdownLoaded: false })
      commit('mutateDropdownCommonConfig', { hasDropdownLoaded: false })
      commit('mutateWarehouseProperties', { hasDropdownLoaded: false })
      commit('IrriConfig/mutateCommonObj', { hasDropdownLoaded: false })
      commit('incentiveGrant/mutateIncentiveGrantServiceProperties', { hasDropdownLoaded: false })
      commit('SeedsFertilizer/mutateCommonObj', { hasDropdownLoaded: false })
      commit('Portal/mutateCommonDropdown', { hasDropdownLoaded: false })
      commit('Portal/mutateExternalagriDropdown', { hasDropdownLoaded: false })
      commit('Portal/mutateAgriResearchDropdown', { hasDropdownLoaded: false })
      commit('Portal/mutateTrainDropdown', { hasDropdownLoaded: false })
      commit('Portal/mutateSeedsFertilizerDropdown', { hasDropdownLoaded: false })
      commit('ExternalIncentiveFarmer/mutateExternalIncentiveFarmerDropdown', { hasDropdownLoaded: false })
      commit('PortalFaq/resetPortalState')
      commit('PortalNotice/resetPortalState')
      commit('PortalNews/resetPortalState')
      commit('PortalAllServices/resetPortalState')
      commit('PortalServiceDetails/resetPortalState')
      commit('PortalProductDetails/resetPortalState')
      commit('PortalNewsDetails/resetPortalState')
    },
    // Called on admin/office login: admins never use the citizen (external) panels, so none of
    // those panels' stores are needed
    resetExternalPanelStores ({ commit }) {
      commit('ExternalUserIrrigation/resetExternalState')
      commit('ExternalUserAuth/resetExternalState')
      commit('ExternalUserTraining/resetExternalState')
      commit('ExternalLrcpn/resetExternalState')
      commit('ExternalAgriResearch/resetExternalState')
      commit('ExternalIncentiveFarmer/resetExternalState')
    },
    setNotification ({ commit }, payload) {
      commit('setNotification', payload)
    },
    clearStoreBasedOnLayout ({ commit }, payload) {
      commit('clearStoreBasedOnLayout', payload)
    },
    setDataFilteringParam ({ commit }, payload) {
      commit('setDataFilteringParam', payload)
    },
    setCurrentFiscalYearId ({ commit }, payload) {
      commit('setCurrentFiscalYearId', payload)
    }
  }
